var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.20312,
    y: 0.821411,
    width: 1.6,
    height: 13.0952,
    rx: 0.8,
    fill: "#0066FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40156 8.1875C0.959735 8.1875 0.601563 7.82933 0.601563 7.3875V7.3506C0.601563 6.90877 0.959735 6.5506 1.40156 6.5506L12.6016 6.5506C13.0434 6.5506 13.4016 6.90877 13.4016 7.3506V7.3875C13.4016 7.82933 13.0434 8.1875 12.6016 8.1875H1.40156Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.db05eecd84134a1288a52f79eb959025.svg";
export { ForwardRef as ReactComponent };